import { create } from 'zustand';
import { tokenStorage } from '@/services/httpClient';
import { useAppStore, hydrateAppStore } from './useAppStore';
import { hydrateSettingsStore } from './useSettingsStore';

interface AuthState {
  ready: boolean;
  authenticated: boolean;
  phone: string | null;
  initialize: () => Promise<void>;
  setAuthenticated: (phone: string) => void;
  signOut: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  ready: false,
  authenticated: false,
  phone: null,

  async initialize() {
    // Hydrate the global app store first so sync, device id, and active
    // store are visible to any consumer that mounts after this resolves.
    await hydrateAppStore();
    await hydrateSettingsStore();
    const has = await tokenStorage.hasSession();
    const phone = useAppStore.getState().currentUser?.phone ?? null;
    set({ ready: true, authenticated: has, phone });
  },

  setAuthenticated(phone) {
    set({ authenticated: true, phone });
  },

  async signOut() {
    await useAppStore.getState().logout();
    set({ authenticated: false, phone: null });
  },
}));
